import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import Utils from "src/utils/Utils";
import store from "../../../store";

class LinkDevicesTask extends AbstractRequestTask {
	constructor(params) {
		super();
		this.ownParams = params;
		this.version = 'v1';
		this.method = 'POST';
	}

	getMethod() {
		return "POST";
	}

	getEncType() {
		return 'application/json';
	}

	getQueryStringParams() {
		const params = super.getParams();
		delete params.api_version;
		delete params.HKS;
		delete params.format;
		delete params.user_id;
        delete params.device_name;
        delete params.device_so;
        delete params.user_token;
		const qsParams = Object.assign({}, params, {key_action: this.ownParams.keyAction});
		return Utils.buildQueryParams(qsParams);
	}

	getParams() {
		const params = super.getParams();
		const user = store.getState().user;
		const user_id = user.user_id || "";
		delete params.api_version;
		delete params.HKS;
		delete this.ownParams.userId;
	}

	getUrl() {
		const protocol = 'https';
		const server = Launcher.get("akamai_mfwk");
		const apiname = 'link-devices';
		const version = this.version;
		const endpoint = 'services/user';

		const urlLinkDevices = `${protocol}://${server}/${endpoint}/${version}/${apiname}?${this.getQueryStringParams()}`;
        return urlLinkDevices;
	}
}

export default LinkDevicesTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/otp/LinkDevicesTask.js